<template>
  <div class="add-mapper-id-individual">
    <v-card class="px-3 py-3">
      <v-row class="pt-0">
        <v-col cols="10" class="py-0">
          <div>
            <span>{{ $t('lbl.processSetup.mapper_edi_specific') }} </span>
          </div>
        </v-col>
        <v-col cols="2" class="py-0">
          <v-icon class="pr-0" :disabled="isHistory" @click="addSrm()">
            mdi-plus
          </v-icon>
        </v-col>
      </v-row>
      <v-row v-if="mapper.isUseDifferentEDI">
        <v-col class="py-0">
          <v-row class="pr-3 pl-0 pt-0 srm-list" v-for="srm in mapper.listSrm" :key="srm.id">
            <v-col cols="5" class="pr-0 pt-0 pb-2">
              <v-autocomplete
                :ref="mapper.mapperId + 'selectSender'"
                v-model="srm.sender"
                @change="selectSender(srm)"
                :items="getSenderList"
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :rules="rules.selCompEdiIdList"
                hide-details
                :readonly="isHistory"
                outlined
                dense
                label=""
                height="25"
                :placeholder="$t('lbl.processSetup.mapper_edi_sender')"
                class="custom-placeholder"
                :id="'sender' + mapper.mapperId + srm.sender + srm.id"
                item-text="srIdQlfr"
                item-value="id"
                return-object
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="5" class="pr-0 pl-1 pt-0">
              <v-autocomplete
                :ref="mapper.mapperId + 'selectRecipient'"
                v-model="srm.recipient"
                @change="selectRecipient(srm)"
                :items="getRecipientList"
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :rules="rules.selPrnrEdiIdList"
                :readonly="isHistory"
                hide-details
                outlined
                dense
                label=""
                height="25"
                :placeholder="$t('lbl.processSetup.mapper_edi_receipt')"
                class="custom-placeholder ml-2"
                :id="'recipient' + mapper.mapperId + srm.recipient + srm.id"
                item-text="srIdQlfr"
                item-value="id"
                return-object
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="2" class="pr-0 pl-6 pt-0">
              <v-icon @click="removeSrm(srm)" :disabled="isHistory">
                mdi-minus
              </v-icon>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import $ from 'jquery';
export default {
  props: {
    isHistory: {
      default: false,
    },
    senderList: {
      default: [],
    },
    recipientList: {
      default: [],
    },
  },
  data() {
    return {
      mapper: {},
      rules: {
        selCompEdiIdList: [(v) => !!v],
        selPrnrEdiIdList: [(v) => !!v],
      },
    };
  },
  watch: {
    mapper: {
      handler: function(val, oldVal) {
        let indexSrm = 1;
        let listSrm = this.mapper.listSrm;
        for (let i = 0; i < listSrm.length; i++) {
          if (indexSrm < listSrm[i].id) indexSrm = listSrm[i].id;
        }
        this.mapper.indexSrm = indexSrm;
      },
      deep: true,
    },
    senderList() {
      return this.senderList;
    },
    recipientList() {
      return this.recipientList;
    },
  },
  computed: {
    getSenderList() {
      return this.senderList;
    },
    getRecipientList() {
      return this.recipientList;
    },
  },
  created() {},
  methods: {
    removeSrm(srm) {
      let self = this;
      $('.proc-component.v-card.v-sheet').each(function() {
        let comp = $(this)[0].__vue__.$parent;
        if (comp.comTp == 'MAP' && comp.nodeId === self.mapper.nodeId) {
          comp.removeSrm(srm);
        }
      });
    },
    addSrm() {
      let self = this;
      if (!this.mapper.isUseDifferentEDI) {
        $('.proc-component.v-card.v-sheet').each(function() {
          let comp = $(this)[0].__vue__.$parent;
          if (comp.comTp == 'MAP' && comp.nodeId === self.mapper.nodeId) {
            comp.isUseDifferentEDI = true;
          }
        });
      } else {
        for (let i = 0; i < this.mapper.listSrm.length; i++) {
          if (this.mapper.listSrm[i].sender == '') {
            this.$refs[this.mapper.mapperId + 'selectSender'][i].focus();
            return;
          } else if (this.mapper.listSrm[i].recipient == '') {
            this.$refs[this.mapper.mapperId + 'selectRecipient'][i].focus();
            return;
          }
        }
        if (this.mapper.listSrm.length < 5) {
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            if (comp.comTp == 'MAP' && comp.nodeId === self.mapper.nodeId) {
              comp.indexSrm = self.mapper.indexSrm;
              comp.addSrm();
            }
          });
        }
      }
    },
    selectSender(srm) {
      let self = this;
      let lenListSrm = this.mapper.listSrm.length;
      let indexClear;
      let isHave = false;
      if (lenListSrm > 1) {
        for (let i = 0; i < lenListSrm; i++) {
          if (srm.id == this.mapper.listSrm[i].id) {
            indexClear = i;
            continue;
          }
          if (
            this.mapper.listSrm[i].sender.id == srm.sender.id &&
            this.mapper.listSrm[i].recipient.id == srm.recipient.id
          ) {
            isHave = true;
          }
        }
      } else {
        $('.proc-component.v-card.v-sheet').each(function() {
          let comp = $(this)[0].__vue__.$parent;
          if (comp.comTp == 'MAP' && comp.nodeId === self.mapper.nodeId) {
            comp.listSrm = self.mapper.listSrm;
            comp.selectSender(srm);
          }
        });
      }
      this.$nextTick((x) => {
        if (isHave) {
          this.mapper.listSrm[indexClear].sender = '';
          this.$refs[this.mapper.mapperId + 'selectSender'][indexClear].focus();
        } else {
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            if (comp.comTp == 'MAP' && comp.nodeId === self.mapper.nodeId) {
              comp.listSrm = self.mapper.listSrm;
              comp.selectSender(srm);
            }
          });
        }
      });
    },
    selectRecipient(srm) {
      let self = this;
      let lenListSrm = this.mapper.listSrm.length;
      let indexClear;
      let isHave = false;
      if (lenListSrm > 1) {
        for (let i = 0; i < lenListSrm; i++) {
          if (srm.id == this.mapper.listSrm[i].id) {
            indexClear = i;
            continue;
          }
          if (
            this.mapper.listSrm[i].sender.id == srm.sender.id &&
            this.mapper.listSrm[i].recipient.id == srm.recipient.id
          ) {
            isHave = true;
          }
        }
      } else {
        $('.proc-component.v-card.v-sheet').each(function() {
          let comp = $(this)[0].__vue__.$parent;
          if (comp.comTp == 'MAP' && comp.nodeId === self.mapper.nodeId) {
            comp.listSrm = self.mapper.listSrm;
            comp.selectRecipient(srm);
          }
        });
      }
      this.$nextTick((x) => {
        if (isHave) {
          this.mapper.listSrm[indexClear].recipient = '';
          this.$refs[this.mapper.mapperId + 'selectRecipient'][indexClear].focus();
        } else {
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            if (comp.comTp == 'MAP' && comp.nodeId === self.mapper.nodeId) {
              comp.listSrm = self.mapper.listSrm;
              comp.selectRecipient(srm);
            }
          });
        }
      });
    },
  },
};
</script>

<style></style>
